import { Component } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';

import { environment } from '@cp/http';

import { AppConfigService } from '@library/app.config';
import { BrandingService } from '@library/common/branding';
import {
   BreakpointService,
   BrowserCheckService,
   EnvironmentService,
   ErrorMessageService,
   GoogleAnalyticsService,
   PrefetchService,
   TextService,
   MaintenanceService,
   PortalService,
} from '@library/core/services';

import * as FullStory from '@fullstory/browser';
@Component({
   selector: 'app-root',
   template: `<router-outlet></router-outlet>`,
})
export class AppComponent {
   constructor(
      public router: Router,
      public brand: BrandingService,
      private error: ErrorMessageService,
      private e: EnvironmentService,
      private gtag: GoogleAnalyticsService,
      private appConfig: AppConfigService,
      private check: BrowserCheckService,
      private breakpoints: BreakpointService,
      private text: TextService,
      private prefetch: PrefetchService,
      private maintenance: MaintenanceService,
      private portalService: PortalService,
   ) {
      this.portalService.current = 'customer';

      this.e.environment = environment;
      this.gtag.load( environment?.gtagId );
      this.breakpoints.tap();
      this.check.check();
      this.maintenance.check();
      FullStory.init({ orgId: 'o-1MB0F2-na1', devMode: false });

      // console.log( 'requesting server', this.server );

      this.appConfig.load();

      this.text.loginTitle = `Ship and Track with Our Customer Portal`;
      this.text.loginSubTitle = `Designed to bring business value to you,
         Our Customer Portal will provide access to vital information on all your shipments.
         Log in today to book or track your freight.`;

      this.prefetch.items = [
         'servicelevels',
         'currencies',
         'countries',
      ];

      const whitelist = [
         '/error',
         '/termsagree',
      ];

      this.router.events.subscribe(event => {
         if ( event instanceof NavigationStart && !whitelist.includes( event.url )) {
            this.error.resetErrors();
         }
      });
   }
}
